// Central site data for Auto Socorro Pimenta

export const CONTACT = {
  name: "Auto Socorro Pimenta",
  phoneDisplay: "(69) 3451-2112",
  phoneTel: "+556934512112",
  whatsappDisplay: "(69) 99904-0973",
  whatsappNumber: "5569999040973",
  instagram: "https://www.instagram.com/auto_socorro_pimenta_",
  instagramHandle: "@auto_socorro_pimenta_",
  years: "20",
};

export const IMAGES = {
  logo: "https://customer-assets.emergentagent.com/job_f27da418-ff2e-4da2-af9f-43e536aedb4c/artifacts/ywcl1o0o_Captura_de_Tela_2026-07-11_a%CC%80s_09.22.25-removebg-preview.png",
  hero: "https://customer-assets.emergentagent.com/job_guincho-24h-6/artifacts/ug4kkydm_WhatsApp%20Image%202026-07-10%20at%2016.04.01-2.jpeg",
  heroFleet: "https://customer-assets.emergentagent.com/job_f27da418-ff2e-4da2-af9f-43e536aedb4c/artifacts/qzqldvf2_WhatsApp%20Image%202026-07-10%20at%2016.04.02.jpeg",
  highwayRescue: "https://customer-assets.emergentagent.com/job_f27da418-ff2e-4da2-af9f-43e536aedb4c/artifacts/vdyonf3f_WhatsApp%20Image%202026-07-10%20at%2016.04.00.jpeg",
  cattleTrailer: "https://customer-assets.emergentagent.com/job_f27da418-ff2e-4da2-af9f-43e536aedb4c/artifacts/qmw4a5km_WhatsApp%20Image%202026-07-10%20at%2016.04.01-2.jpeg",
  fleetDirtLot: "https://customer-assets.emergentagent.com/job_f27da418-ff2e-4da2-af9f-43e536aedb4c/artifacts/84968g44_Captura%20de%20Tela%202026-07-11%20a%CC%80s%2009.24.00.png",
  work1: "https://customer-assets.emergentagent.com/job_guincho-24h-6/artifacts/inllv3a4_Captura%20de%20Tela%202026-07-11%20a%CC%80s%2009.20.28.png",
  work2: "https://customer-assets.emergentagent.com/job_guincho-24h-6/artifacts/h4vijx0r_WhatsApp%20Image%202026-07-10%20at%2016.04.00-3.jpeg",
  work3: "https://customer-assets.emergentagent.com/job_guincho-24h-6/artifacts/0o3z2sye_Captura%20de%20Tela%202026-07-11%20a%CC%80s%2009.20.11.png",
  work4: "https://customer-assets.emergentagent.com/job_guincho-24h-6/artifacts/8jvrvsr7_WhatsApp%20Image%202026-07-13%20at%2013.06.16.jpeg",
  work5: "https://customer-assets.emergentagent.com/job_guincho-24h-6/artifacts/hsenc2gx_WhatsApp%20Image%202026-07-13%20at%2013.06.17.jpeg",
  work6: "https://customer-assets.emergentagent.com/job_guincho-24h-6/artifacts/ip2b8bey_WhatsApp%20Image%202026-07-13%20at%2013.07.20.jpeg",
  work7: "https://customer-assets.emergentagent.com/job_guincho-24h-6/artifacts/190ik788_WhatsApp%20Image%202026-07-13%20at%2013.07.44.jpeg",
};

export const NAV = [
  { label: "Início", path: "/" },
  { label: "Serviços", path: "/servicos" },
  { label: "Quem Somos", path: "/quem-somos" },
  { label: "Contato", path: "/contato" },
];

export const BENEFITS = [
  "Atendimento 24 Horas",
  "Mais de 20 anos de experiência",
  "Guincho Leve e Pesado",
  "Transporte de Máquinas",
  "Atendimento para Seguradoras",
  "Cobertura em RO e MT",
];

export const SERVICES = [
  {
    slug: "guincho-leve",
    title: "Guincho Leve",
    short: "Reboque rápido e seguro para carros, motos, utilitários e veículos de passeio.",
    icon: "Car",
    image: IMAGES.heroFleet,
  },
  {
    slug: "guincho-pesado",
    title: "Guincho Pesado",
    short: "Resgate e reboque de caminhões, carretas, ônibus e veículos de grande porte.",
    icon: "Truck",
    image: IMAGES.highwayRescue,
  },
  {
    slug: "locacao-munck",
    title: "Transporte de Máquinas",
    short: "Içamento e movimentação de cargas, máquinas, containers e estruturas metálicas.",
    icon: "Crane",
    image: IMAGES.cattleTrailer,
  },
  {
    slug: "auto-socorro-24h",
    title: "Auto Socorro 24 Horas",
    short: "Assistência emergencial a qualquer hora do dia ou da noite, todos os dias.",
    icon: "Clock",
    image: IMAGES.fleetDirtLot,
  },
  {
    slug: "assistencia-rodoviaria",
    title: "Assistência Rodoviária",
    short: "Suporte completo em rodovias de Rondônia e Mato Grosso com equipe especializada.",
    icon: "Road",
    image: IMAGES.highwayRescue,
  },
  {
    slug: "seguradoras",
    title: "Atendimento para Seguradoras",
    short: "Parceria ágil e confiável com seguradoras para remoção e resgate de veículos.",
    icon: "ShieldCheck",
    image: IMAGES.heroFleet,
  },
];

export const DIFFERENTIALS = [
  { title: "Mais de 20 anos de experiência", icon: "Medal" },
  { title: "Atendimento imediato", icon: "Lightning" },
  { title: "Equipe especializada", icon: "UsersThree" },
  { title: "Equipamentos modernos", icon: "Gear" },
  { title: "Atendimento 24 horas", icon: "Clock" },
  { title: "Cobertura em RO e MT", icon: "MapTrifold" },
  { title: "Preço justo", icon: "Tag" },
  { title: "Segurança", icon: "ShieldCheck" },
];

export const TESTIMONIALS = [
  { name: "João Carlos", city: "Ji-Paraná", text: "Meu caminhão quebrou durante a madrugada e fui atendido rapidamente. Equipe muito profissional." },
  { name: "Mariana Oliveira", city: "Vilhena", text: "Excelente atendimento. O guincho chegou antes do prazo informado." },
  { name: "Roberto Almeida", city: "Pimenta Bueno", text: "Precisávamos de um munck para movimentar um equipamento pesado. Serviço impecável." },
  { name: "Ana Paula Souza", city: "Cacoal", text: "Atendimento rápido e muito organizado." },
  { name: "Fernando Lima", city: "Sapezal", text: "Empresa séria e extremamente competente." },
  { name: "Carlos Henrique", city: "Rolim de Moura", text: "Já utilizei duas vezes e sempre fui muito bem atendido." },
  { name: "Juliana Martins", city: "Campos de Júlio", text: "Profissionais muito educados e serviço de excelente qualidade." },
  { name: "Ricardo Gomes", city: "Comodoro", text: "Atendimento nota 10. Recomendo." },
];

export const REGIONS = [
  { city: "Jaru", uf: "RO", lat: -10.4392, lng: -62.4664 },
  { city: "Ouro Preto do Oeste", uf: "RO", lat: -10.7482, lng: -62.2159 },
  { city: "Ji-Paraná", uf: "RO", lat: -10.8853, lng: -61.9517 },
  { city: "São Miguel do Guaporé", uf: "RO", lat: -11.6957, lng: -62.7178 },
  { city: "São Francisco do Guaporé", uf: "RO", lat: -12.0530, lng: -63.5680 },
  { city: "Rolim de Moura", uf: "RO", lat: -11.7271, lng: -61.7717 },
  { city: "Cacoal", uf: "RO", lat: -11.4343, lng: -61.4562 },
  { city: "Pimenta Bueno", uf: "RO", lat: -11.6725, lng: -61.1936 },
  { city: "Colorado do Oeste", uf: "RO", lat: -13.1174, lng: -60.5453 },
  { city: "Vilhena", uf: "RO", lat: -12.7404, lng: -60.1458 },
  { city: "Comodoro", uf: "MT", lat: -13.6616, lng: -59.7871 },
  { city: "Campos de Júlio", uf: "MT", lat: -13.7647, lng: -59.2706 },
  { city: "Sapezal", uf: "MT", lat: -13.5423, lng: -58.8138 },
];

export const FAQ = [
  { q: "Vocês atendem 24 horas?", a: "Sim. A Auto Socorro Pimenta oferece atendimento 24 horas por dia, 7 dias por semana, incluindo finais de semana e feriados. Nossa equipe está sempre de prontidão para atender emergências em Rondônia e Mato Grosso." },
  { q: "Quanto tempo demora para o guincho chegar?", a: "O tempo de chegada depende da sua localização, mas trabalhamos com frota própria distribuída estrategicamente pelas filiais de Pimenta Bueno, Vilhena e Sapezal para garantir o atendimento mais rápido possível. Ao entrar em contato pelo WhatsApp, informamos uma estimativa de tempo." },
  { q: "Vocês atendem caminhões?", a: "Sim. Somos especializados em guincho pesado, com equipamentos preparados para reboque e resgate de caminhões, carretas, ônibus e veículos de grande porte com total segurança." },
  { q: "Fazem transporte de máquinas?", a: "Sim. Realizamos a movimentação e o transporte de máquinas, equipamentos, estruturas metálicas e containers utilizando caminhão munck e pranchas apropriadas para cada tipo de carga." },
  { q: "Atendem seguradoras?", a: "Sim. Temos ampla experiência no atendimento para seguradoras, com agilidade, cobertura regional e processos que facilitam a remoção e o resgate de veículos segurados 24 horas por dia." },
  { q: "Quais cidades atendem?", a: "Atendemos Pimenta Bueno, Vilhena, Cacoal, Ji-Paraná, Jaru, Ouro Preto do Oeste, São Miguel do Guaporé, São Francisco do Guaporé, Rolim de Moura, Colorado do Oeste (RO), além de Comodoro, Campos de Júlio e Sapezal (MT) e cidades vizinhas." },
  { q: "Como solicitar um guincho?", a: "É simples: clique no botão do WhatsApp em qualquer parte do site ou ligue para nós. Informe sua localização, o tipo de veículo e a situação, e nossa equipe se encarrega do restante." },
  { q: "Qual o telefone da Auto Socorro Pimenta?", a: "Você pode nos ligar no (69) 3451-2112 ou falar diretamente pelo WhatsApp no (69) 99904-0973, disponível 24 horas por dia." },
];

// Keyword links for SEO footer / internal linking
export const SEO_LINKS = [
  "Guincho em Pimenta Bueno", "Guincho 24 Horas Pimenta Bueno", "Auto Socorro Pimenta Bueno",
  "Guincho em Vilhena", "Auto Socorro Vilhena", "Guincho 24 Horas Vilhena",
  "Guincho em Cacoal", "Auto Socorro Cacoal", "Guincho em Ji-Paraná", "Guincho em Jaru",
  "Guincho em Ouro Preto do Oeste", "Guincho em Rolim de Moura", "Guincho em São Miguel do Guaporé",
  "Guincho em São Francisco do Guaporé", "Guincho em Colorado do Oeste", "Guincho em Comodoro MT",
  "Guincho em Campos de Júlio MT", "Guincho em Sapezal MT", "Transporte de Máquinas em Rondônia",
  "Transporte de Máquinas em Mato Grosso", "Guincho Leve e Pesado", "Assistência Rodoviária 24 Horas",
  "Reboque para Caminhões", "Reboque para Veículos", "Auto Socorro 24 Horas",
];
